# SCROLL BAR CALC
class ScrollBarCalc
    constructor: ->
        @.scrollBarWidth = 0
        @.resizeDelay = 300
        @.resizeInterval = undefined

        @.SetScrollBarWidth()
        @.InitEvents()
        return
    
    InitEvents: ->
        self = @
        window.addEventListener 'resize', (e) ->
            window.clearInterval self.resizeInterval
            self.resizeInterval = window.setInterval ->
                window.clearInterval self.resizeInterval
                self.SetScrollBarWidth()
                return
            , self.resizeDelay
            return
        return

    SetScrollBarWidth: ->
        @.scrollBarWidth = window.innerWidth - document.documentElement.clientWidth
        document.documentElement.style.setProperty '--scrollbar-width', @.scrollBarWidth + 'px'
        return

window.rsmScrollBarCalc = new ScrollBarCalc()

# --------------------------------------------------------------------------------------

# SCROLL TO ANCHOR
class ScrollToAnchor
    constructor: ->
        @.$anchorLinks = []
        @.scrollTimeout

        @.RefreshAnchorLinkList()
        @.InitEvents()
        return

    InitEvents: ->
        self = @
        if location.hash
            window.scrollTo 0,0
            @.scrollTimeout = window.setTimeout ->
                window.scrollTo 0,0
                self.ScrollToElem document.getElementById location.hash.substr(1)
            , 100
        @.BindAnchorLinks()
        return

    BindAnchorLinks: ->
        self = @
        @.$anchorLinks.forEach (anchorLink) ->
            if !anchorLink.classList.contains 'anchor-link--bound'
                anchorLink.addEventListener 'click', (e) ->
                    e.preventDefault()
                    hash = @.href.substr(@.href.indexOf("#"))
                    location.hash = hash
                    window.scrollTo 0,0
                    @.scrollTimeout = window.setTimeout ->
                        window.scrollTo 0,0
                        self.ScrollToElem document.getElementById hash.substr(1)
                        return
                    return
                anchorLink.classList.add 'anchor-link--bound'
            return
        return


    ScrollToElem: (elem) ->
        if elem
            window.scrollTo {
                behavior: 'smooth',
                left: 0,
                top: elem.getBoundingClientRect().top - (document.querySelector('.header').offsetHeight + 50)
            }
        return
    
    RefreshAnchorLinkList: ->
        self = @
        document.querySelectorAll 'a[href^="#"]:not(.anchor-link--bound)'
            .forEach (anchorLink) ->
                self.$anchorLinks.push anchorLink
                return
        return


window.rsmScrollToAnchor = new ScrollToAnchor()
window.addEventListener 'bind-components', (e) ->
    window.rsmScrollToAnchor.RefreshAnchorLinkList()
    return